import React from 'react';
import PropTypes from 'prop-types';

const amountToFixed = amount => parseFloat((amount / 100)).toFixed(2);

const GiftCard = ({ giftProduct }) => (
  <div className="gift-card-container">
    <div className="gift-card-image" style={giftProduct.imagePath ? { backgroundImage: `url(${giftProduct.imagePath})` } : null} />
    <div className="gift-card-details">
      <span>${amountToFixed(giftProduct.price)}</span>
      <p>{giftProduct.description}</p>
    </div>
  </div>
);

GiftCard.propTypes = {
  giftProduct: PropTypes.shape({}).isRequired,
};

export default GiftCard;
